import { render, staticRenderFns } from "./messageSelectUser.vue?vue&type=template&id=5590ff4f&"
import script from "./messageSelectUser.vue?vue&type=script&lang=js&"
export * from "./messageSelectUser.vue?vue&type=script&lang=js&"
import style0 from "./messageSelectUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports